import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Orbit, LogOut, Shield } from "lucide-react";

export default function Nav({ variant = "solid" }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [online, setOnline] = useState(null);
  useEffect(() => {
    const poll = () => api.get("/presence").then((r) => setOnline(r.data.online)).catch(() => {});
    poll();
    const t = setInterval(poll, 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <header className={`sticky top-0 z-40 ${variant === "solid" ? "orbit-glass" : ""} border-b border-white/5`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-brand-logo">
          <div className="relative w-8 h-8 rounded-full bg-gradient-to-br from-cyan-400 to-fuchsia-500 flex items-center justify-center">
            <Orbit className="w-4 h-4 text-slate-950" strokeWidth={3} />
            <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-emerald-400 orbit-glow-cyan" />
          </div>
          <span className="font-display text-xl font-extrabold tracking-tight">ORBIT<span className="orbit-gradient-text">HELLO</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-300">
          <a href="/#how" className="hover:text-cyan-300 transition">How it works</a>
          <Link to="/safety" className="hover:text-cyan-300 transition" data-testid="nav-safety-link">Safety</Link>
          <Link to="/pricing" className="hover:text-cyan-300 transition" data-testid="nav-pricing-link">Pricing</Link>
          <a href="/#faq" className="hover:text-cyan-300 transition">FAQ</a>
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden sm:inline-flex items-center gap-2 text-xs font-mono uppercase text-emerald-300" data-testid="nav-online-counter">
            <span className="orbit-live-dot" /> {online === null ? "…" : online} online
          </span>
          {user ? (
            <>
              {(user.role === "admin" || user.role === "moderator") && (
                <Link to="/admin" className="text-slate-300 hover:text-cyan-300 p-2" data-testid="nav-admin-link" title="Admin">
                  <Shield className="w-4 h-4" />
                </Link>
              )}
              <Link to="/dashboard" className="text-sm text-slate-200 hover:text-cyan-300" data-testid="nav-dashboard-link">Dashboard</Link>
              <button onClick={async () => { await logout(); nav("/"); }} className="text-slate-400 hover:text-rose-400 p-2" data-testid="nav-logout-btn" title="Sign out">
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <>
              <Link to="/auth" className="text-sm text-slate-300 hover:text-cyan-300" data-testid="nav-signin-link">Sign in</Link>
              <button onClick={() => nav("/auth?tab=register")} className="orbit-btn-primary text-sm" data-testid="nav-start-chat-btn">
                Start Chatting
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
